import { dealFormField } from '@openx/types/deal.ts';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledRHFTextField } from './styled/index.ts';

type IdCustomRadioProps = { disabled?: boolean };

export const IdCustomRadio = ({ disabled = false }: IdCustomRadioProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledRHFTextField
      name={dealFormField.CUSTOM_DEAL_ID}
      data-test="radio-custom-input"
      placeholder={t('Type your Deal ID (example: OX-xxx-xxxxxx)')}
      fullWidth
      disabled={disabled}
    />
  );
};
